import { render, staticRenderFns } from "./setting-partial.vue?vue&type=template&id=3308e96c"
import script from "./setting-partial.vue?vue&type=script&lang=js"
export * from "./setting-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports